import moment from 'moment';
import { serverBus } from '../../main';
import {
  consultarOrdenes,
  consultarOrdenesEstado,
  descargarOrdenes,
} from '../../apiService/request/gestionSeguimientos';
import { consultarTipoEncuentroSeguimiento, crearCuestionario, consultarEstructuraCuestionarioPorId } from '../../apiService/request/CrudSeguimiento';
import { consultarOrden, crearOrdenDesdeFormulario } from '../../apiService/request/CrudOrdenes';
import { reemplazarCaracteresEspeciales } from '../metodos_comunes';

export default {
  data() {
    return {
      banderaSoloUnaOpcionEstado: false,
      valorSeleccionadoTipoGestion: '',
      fechaInicial: '',
      fechaFinal: '',
      fechaHoy: Date.now(),
      fechaSeleccionada: '',
      miliSegundos: Number,
      estadosSeleccionados: ['autorizada'],
      tipo_gestion: '',
      seguimiento: [
        {
          nombre_lista: 'Tipo gestión',
          key_lista: 'tipo_gestion',
          opciones_lista:
          [
            {
              nombre: 'Gestión llamadas',
              key: 'llamada',
              valor: 'llamada',
            },
            {
              nombre: 'Gestión seguimientos',
              key: 'seguimiento',
              valor: 'seguimiento',
            },
            {
              nombre: 'Gestión ayudas diagnósticas',
              key: 'ayuda_diagnostica',
              valor: 'ayuda diagnóstica',
            },
          ],
        },
      ],
      estados: ['nueva', 'generada', 'autorizada', 'no_autorizada', 'externa', 'asignada', 'factura', 'procesada', 'completada', 'no_completada', 'anulada'],
      valorSeleccionado: '',
    };
  },
  beforeUpdate() {
  },
  methods: {
    convertirDiasAMilisegundos() {
      this.fechaActual = moment(Number(this.fechaHoy)).format('MMM D YYYY');
      this.miliSegundos = this.diaSeleccionado;
      this.fechaSeleccionada = moment(Number(this.miliSegundos)).format('MMM D YYYY');
      // this.miliSegundos = this.diaSeleccionado * 86400000;
      // this.fechaSeleccionada = moment(Number(this.fechaHoy - this.miliSegundos)).format('MMM D YYYY');
    },
    seleccionSeguimientos(valorSeleccionado, opcionSeleccionadaTipoGestion, estados, fechaInicial, fechaFinal) {
      this.banderaGrafica = false;
      console.log('seleccionSeguimientos', valorSeleccionado, opcionSeleccionadaTipoGestion, estados, fechaInicial, fechaFinal);
      this.arrayGraficas = [];
      // const self = this.seguimiento[0].opciones_lista;
      // console.log('valorSeleccionado:', opcionSeleccionadaTipoGestion, self);
      // const elementoSeleccionado = self.filter(
      //   element => element.nombre == opcionSeleccionadaTipoGestion,

      // );
      // console.log('elementoSeleccionado:', elementoSeleccionado);
      this.valorSeleccionado = valorSeleccionado;

      // this.tipo_gestion = elementoSeleccionado[0].key;
      this.tituloPadre = '';
      this.respuesta = [];
      this.consultarDatosGrafica(opcionSeleccionadaTipoGestion, fechaInicial, fechaFinal, estados);
    },
    async formularioActualizado() {
      try {
        this.$store.dispatch('setCargando', true);
        const respuesta = await crearOrdenDesdeFormulario(this.$store.state.provider_email, this.idFormulario, this.id, this.cedulaPaciente);
        this.$store.dispatch('cambiarEstadoModal', true);
        this.$store.dispatch('cambiarMensajeModal', respuesta);
      } finally {
        this.$store.dispatch('setCargando', false);
      }
    },
    getGraphicData(response, index) {
      const maximo = Math.max.apply(null, response.data.data.series);
      const max = maximo + 1;
      this.opciones[index].yaxis.max = !max ? 0 : max;
      this.opciones[index].xaxis.categories = response.data.data.ejeX;
      this.arrayGraficas[index] = {
        options: this.opciones[index],
        series: [{ data: response.data.data.series }],
      };
    },
    async getOrder(docId) {
      try {
        const response = await consultarOrden(docId, 'ordenes');
        if (response && response.data && response.data.data && response.data.data.variables) {
          this.$store.dispatch(
            'setVariablesFormularios',
            response.data.data.variables,
          );
          this.$store.dispatch('setNombreFormulario', response.data.data.key);
          this.$store.dispatch('setColeccion', response.data.data.coleccion);
          this.overlay = true;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.verComponente = 'ordenes';
      }
    },
    async consultarTipoEncuentroSeguimientoPaciente(origen, id) {
      try {
        const respuesta = await consultarTipoEncuentroSeguimiento(origen, id);
        if (origen == 'encuentros') {
          this.$store.dispatch('setConsultarEncuentro', respuesta.data.data.key);
        } else if (origen == 'seguimientos') {
          this.$store.dispatch('setNombreEvento', respuesta.data.data.key);
        }
      } finally {
      }
    },
    async successFunction(item) {
      if (item.origen == 'seguimientos') {
        this.verComponente = 'seguimientos';
      } else if (item.origen == 'encuentros') {
        this.verComponente = 'encuentros';
      }
      await this.consultarTipoEncuentroSeguimientoPaciente(item.origen, item.id);
      this.$store.dispatch('setId', item.id);
      this.$store.dispatch('setCedulaPaciente', item.documento);
      this.paciente = item;
      this.overlay = true;
      serverBus.$emit('verEncuentroGestion', this.overlay);
    },
    failedFunction(item) {
      this.$store.dispatch('setIdFormulario', item.docId);
      this.$store.dispatch('setCedulaPaciente', item.documento);
      this.paciente = item;
      this.getOrder(item.docId);
    },
    async crearOrden(item) {
      this.$store.dispatch('setCargando', true);
      const respuesta = await crearCuestionario('informacion_ordenes', item.documento, this.$store.state.provider_email, item.id, 'formularios');
      this.$store.dispatch('setCedulaPaciente', item.documento);
      this.cedulaPaciente = item.documento;
      this.idFormulario = respuesta.data.data.docId;
      this.id = item.id;
      this.banderaSubirArchivo = false;
      this.$store.dispatch('setIdFormulario', respuesta.data.data.docId);
      this.consultarEsquemaCuestionarioSeguimiento(respuesta.data.data.docId, 'formularios', 'informacion_ordenes');
    },
    async consultarEsquemaCuestionarioSeguimiento(formulario_id, tipo, tipo_esquema) {
      console.log('tipo_esquema', tipo_esquema);

      try {
        const respuesta = await consultarEstructuraCuestionarioPorId(formulario_id, tipo, tipo_esquema);
        this.preguntasEncuestas = respuesta.data.data.variables;
        this.keyFormulario = respuesta.data.data.key;
        this.$store.dispatch('setBanderaFormularioCreadoPanel', true);
        this.$store.dispatch('setVariablesFormularios', respuesta.data.data.variables);
        this.$store.dispatch('setNombreFormulario', respuesta.data.data.key);
        this.$store.dispatch('setColeccion', respuesta.data.data.coleccion);
        this.overlay = true;
        this.verComponente = 'ordenes';
        this.$store.dispatch('setCargando', false);
      } catch (err) {
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/js/mixins/mixinGraficas.js